import { createStore$ } from '../createStore$';
import { I18nLang } from '../XV2';
import React from 'react';
import { XSButton, XSButtonInput } from '../xs/component/button/XSButton';
import { XSDialog } from '../xs/component/dialog/XSDialog';
import styled from 'styled-components';

const store = createStore$<{
    lang?: I18nLang;
}>({
    cacheKey: 'I18n$',
    initialState: {},
});

export namespace I18n$ {
    export function useLanguage(): [I18nLang | undefined, (value: I18nLang | undefined) => void] {
        const [state, setState] = store.useState();

        return [
            state.lang,
            (value: I18nLang | undefined) => {
                setState((state) => {
                    state.lang = value;
                });
            },
        ];
    }

    export function SelectLanguageDialog(buttonInput: XSButtonInput) {
        const [lang, setLang] = useLanguage();

        return (
            <>
                <XSButton
                    label={'Language'}
                    {...buttonInput}
                    onClick={() => {
                        const dialog = XSDialog.show(<SelectLanguageButtons onClose={() => dialog.close()} />, {
                            size: 'fitContent',
                            background: 'transparent',
                            maxWidth: 480,
                        });
                    }}>
                    <span>{(lang === 'no' && '🇳🇴') || (lang === 'en' && '🇬🇧') || '-'}</span>
                    {buttonInput?.children}
                </XSButton>
            </>
        );
    }

    export function SelectLanguageButtons({ onClose }: { onClose?(): void }) {
        const [lang, setLang] = I18n$.useLanguage();

        const languages = [
            {
                lang: 'en',
                flag: '🇬🇧',
                title: 'English',
            },
            {
                lang: 'no',
                flag: '🇳🇴',
                title: 'Norwegian',
            },
        ];

        return (
            <>
                {/*<XSDialog.Header title={'Choose language'} />*/}

                <DivLanguageGrid>
                    {languages.map((language, index) => (
                        <XSButton
                            key={language.lang}
                            onClick={() => {
                                setLang(language.lang);
                                onClose?.();
                            }}
                            direction={'column'}
                            style={{
                                background: lang === language.lang ? 'var(--rx-color-primary)' : 'white',
                                borderRadius: 8,
                                color: lang === language.lang ? 'white' : 'black',
                                justifyContent: 'flex-start',
                                minHeight: 72,
                                paddingTop: 24,
                                paddingBottom: 24,
                                textTransform: 'uppercase',
                                borderTop: index > 0 ? '1px solid var(--rx-color-border)' : undefined,
                            }}>
                            <span style={{ fontSize: 36, paddingBottom: 4 }}>{language.flag}</span>
                            <span>{language.title}</span>
                        </XSButton>
                    ))}
                </DivLanguageGrid>
            </>
        );
    }
}

const DivLanguageGrid = styled.div`
    display: grid;
    gap: var(--rx-gap);
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    padding: var(--rx-gap);
`;
